import { autoinject, bindingMode, customElement, DOM } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { resolve } from 'framework/script_utilities/object-navigator';
import { GroupBase } from 'support/base_classes/group-base';

@autoinject
@customElement('bs-form-select')
export class FormSelect extends GroupBase {
  @bindable placeholder = '';
  @bindable placeholderValue: unknown = null;
  @bindable({ defaultBindingMode: bindingMode.twoWay }) value: unknown = null;
  @bindable options: unknown[] = [];
  @bindable valuePath = '';
  @bindable namePath = '';
  @bindable classPath = '';
  @bindable matcher = (x, y) => x === y;
  @bindable controlClass = '';
  @bindable disabled = false;
  @bindable({ defaultBindingMode: bindingMode.twoWay }) hasfocus = false;

  constructor(private element: Element) {
    super();
  }

  getValue(option: unknown) {
    return option == null || !this.valuePath ? option : resolve(option, this.valuePath);
  }

  getName(option: unknown) {
    return option == null ? '' : String(this.namePath ? resolve(option, this.namePath) : option);
  }

  getClass(option: unknown) {
    return option == null || !this.classPath ? null : resolve(option, this.classPath);
  }

  blur() {
    this.element.dispatchEvent(DOM.createCustomEvent('blur'));
  }
}
